import React from 'react';
import { usePrevious } from '../../hooks/use-previous';

interface Props {
  location: any;
}

declare global {
  interface Window {
    dataLayer: any;
    digitalData: any;
  }
}

export const TagManager: React.FC<Props> = ({ children, location }) => {
  // Send page views
  const previousLocation = usePrevious(location);
  if (previousLocation && previousLocation.pathname !== location.pathname) {
    window.digitalData.page.url =  '/water-supply/perths-water-supply' + location.pathname;
    window.dataLayer.push({
      event: 'virtualPage',
    });
  }

  return <>{children}</>;
};
